module.exports = __webpack_public_path__ + "static/media/Start Exam 7655-rocket.e424e451.gif";